import { FrontLinkTypeEnum } from '../enums/front-link-type-enum';
import { environment } from '../../../environments/environment';

export const countryConfigES = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 5,
      starredCards1: true,
      starredCards2: true,
      posts: false
    }
  },
  services: {
    brandsServices: [
      {
        title: 'Sampling',
        description: 'Tu marca en cada hogar en minutos',
        frontLink: {
          frontLinkType: FrontLinkTypeEnum.landing,
          slug: 'sampling'
        },
        image: {
          url: environment.url + '/assets/brands/card-sampling.webp'
        }
      },
      {
        title: 'Off-line marketing (Bags&Flyers)',
        description: 'Descubre el servicio de Glovo de Off-line marketing (Bags&Flyers)',
        frontLink: {
          frontLinkType: FrontLinkTypeEnum.landing,
          slug: 'bags-flyers'
        },
        image: {
          url: environment.url + '/assets/brands/card-bags-flyers.webp'
        }
      },
      {
        title: 'Brands Marketing Services (BMS)',
        description: 'Todos los servicios para hacer crecer tu marca dentro de Glovo',
        frontLink: {
          frontLinkType: FrontLinkTypeEnum.landing,
          slug: 'bms'
        },
        image: {
          url: environment.url + '/assets/brands/card-bms.webp'
        }
      },
    ]
  },
  'landing-courier': {
    bikeCollection: 'para-ciclstas-y-scooters',
    carCollection: 'para-conductores-de-coche'
  },
  'landing-custom-products': {
    quickCustomization: 'express-1',
    proCustomization: 'pro-3d',
    design: 'pro-3d',
    logo: 'pro-3d'
  }
};
